define(['jquery', 'core/ajax',
	'core/notification',
	'core/templates',
	'core/modal_factory',
	'core/modal_events'], function ($, ajax, notification, templates, ModalFactory, ModalEvents) {

		return {
			init: function() {
				
				$('.sesson').on('click', function(e) {
					
					var promises = ajax.call([
					{
						methodname: 'local_landing_unload',
						args: {
							userid: 0
						}
					}
					]);

					promises[0].done(function (result) {
						
					}).fail(function () {

					});
				});
				$('.inquiry').on('click', function(e) {

					var inquiry_name = $('.inquiry_name').val();
					var inquiry_email = $('.inquiry_email').val();
					var inquiry_phone = $('.inquiry_phone').val();
					var inquiry_message = $('.inquiry_message').val();

					if (inquiry_name == "") {

						e.preventDefault();
						Swal.fire({
							icon: 'error',
							title: 'Oops...',
							text: 'Please Enter Name!'
						})
					} else if (inquiry_email == "") {

						e.preventDefault();
						Swal.fire({
							icon: 'error',
							title: 'Oops...',
							text: 'Please Enter Email!'
						})
					} else if (inquiry_phone == "") {

						e.preventDefault();
						Swal.fire({
							icon: 'error',
							title: 'Oops...',
							text: 'Please Enter Mobile Number!'
						})
					}  else if (!$.isNumeric(inquiry_phone)) {

						e.preventDefault();
						Swal.fire({
							icon: 'error',
							title: 'Oops...',
							text: 'Please Enter Valid Mobile Number!'
						})
					} else if (inquiry_phone.length != 10) {

						e.preventDefault();
						Swal.fire({
							icon: 'error',
							title: 'Oops...',
							text: 'Please Enter Valid Mobile Number!'
						})
					} else if (inquiry_message == "") {

						e.preventDefault();
						Swal.fire({
							icon: 'error',
							title: 'Oops...',
							text: 'Please Enter Message!'
						})
					} else {

						e.preventDefault();

						var promises = ajax.call([
						{
							methodname: 'local_landing_inquiry',
							args: {
								inquiry_name: inquiry_name.toString(),
								inquiry_email: inquiry_email.toString(),
								inquiry_phone: inquiry_phone.toString(),
								inquiry_message: inquiry_message.toString()
							}
						}
						]);

						promises[0].done(function (result) {
							if (result == "email_exist") {

								e.preventDefault();
								Swal.fire({
									icon: 'error',
									title: 'Oops...',
									text: 'Email Is Already Exists!'
								})

							} else if (result == "email_valid") {

								e.preventDefault();
								Swal.fire({
									icon: 'error',
									title: 'Oops...',
									text: 'Please Enter valid Email!'
								})

							} else if (result == "success") {

								Swal.fire({
									position: 'center',
									icon: 'success',
									title: 'Submited Sucssesfully',
									showConfirmButton: false,
									timer: 1500
								})
								window.location = "../../";

							}
						}).fail(function () {
							e.preventDefault();
							Swal.fire({
								icon: 'error',
								title: 'Oops...',
								text: 'Fail!'
							})
						});
					}
				});
			}
		}
	});
